import { AbstractGameMode } from "../../../abstracts/flow/AbstractGameMode";
import { log } from "../../../abstracts/utils/AbstractConsole";
import { fadeAndStopSound } from "../../../abstracts/utils/SoundUtils";
import { DDD } from "../../DDD";
import { DDDSoundNames } from "../../assetsLoader/DDDAssetsNames";
import { DDDFreespinIdlePresentation } from "../freespin/DDDFreespinIdlePresentation";

export class DDDSuperFreespinIdlePresentation extends DDDFreespinIdlePresentation {
    constructor() {
        super(`DDDSuperFreespinIdlePresentation`);
    }

    protected get gameMode(): AbstractGameMode {
        return AbstractGameMode.SUPER_FREESPIN;
    }

    protected onDefaultStart() {
        log(`${this.id} onDefaultStart()`, this.colorScheme);

        if (
            this.model.data.mode !== AbstractGameMode.SUPER_FREESPIN &&
            this.model.data.nextMode === AbstractGameMode.SUPER_FREESPIN
        ) {
            if (this.model.data.mode === AbstractGameMode.NORMAL) {
                this.keypad.setWin(-1);
            }

            const soundName =
                this.model.data.mode === AbstractGameMode.NORMAL
                    ? DDDSoundNames.MAIN_MUSIC
                    : DDDSoundNames.FREESPIN_MUSIC;

            fadeAndStopSound({
                name: soundName,
                duration: 0.5,
                from: 1,
                to: 0,
            });

            this.winView.showFreespinIntroScreen(
                this.onIntroScreenComplete.bind(this),
                this.model.data.freespinsLeft,
                true
            );

            this.keypad.setZeroBetSpinCounter(DDD.model.data.freespinsLeft);
        } else {
            this.flowPresentationTimeline.resume();
        }
    }
}
